(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.section-header');
this.headerWrapper = this.querySelector('.header-wrapper') || this;
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');
this.hideEvent = new Event('headerHidden');
this.isDesktop = window.innerWidth > 1199;

// Elements to control
this.announcementBar = document.querySelector('.ax-announcement-bar');
this.rowTop = this.querySelector('.header__row-top');
this.rowNav = this.querySelector('.header__row-nav');
this.rowSearchMobile = this.querySelector('.header__row-search-mobile');

// Read announcement sticky settings from the announcement-bar section data attributes
var announcementDesktop = this.announcementBar ? this.announcementBar.dataset.stickyScrollDesktop === 'true' : false;
var announcementMobile = this.announcementBar ? this.announcementBar.dataset.stickyScrollMobile === 'true' : false;
var announcementScrollDown = this.announcementBar ? this.announcementBar.dataset.stickyScrollDown === 'true' : false;

// Read settings from data attributes
this.settings = {
  desktop: {
    announcement: announcementDesktop,
    rowTop: this.dataset.stickyDesktopRowTop === 'true',
    rowNav: this.dataset.stickyDesktopRowNav === 'true'
  },
  mobile: {
    announcement: announcementMobile,
    rowTop: this.dataset.stickyMobileRowTop === 'true',
    search: this.dataset.stickyMobileSearch === 'true'
  },
  scrollDown: {
    enabled: this.dataset.stickyScrollDown === 'true',
    announcement: announcementScrollDown
  }
};

if (this.settings.scrollDown.enabled) {
document.documentElement.classList.add('sticky-scroll-down-enabled');
}

if(this.isDesktop) {
this.header.classList.add('shopify-section-header-sticky');
}

this.onScrollHandler = this.onScroll.bind(this);
this.onResizeHandler = () => { this.isDesktop = window.innerWidth > 1199; };
this.hideHeaderOnScrollUp = () => this.preventReveal = true;

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);
window.addEventListener('resize', this.onResizeHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
window.removeEventListener('resize', this.onResizeHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
if (this.settings.scrollDown.enabled) {
requestAnimationFrame(() => this.reveal(true));
} else {
requestAnimationFrame(this.hide.bind(this));
window.dispatchEvent(this.hideEvent);
}

} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(() => this.reveal(false));
} else {
window.clearTimeout(this.isScrolling);
this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);
requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
this.header.classList.add('sticky-header--hidden');
this.header.classList.remove('sticky-header--reveal');

// Hide everything on scroll down
if (this.announcementBar) {
this.announcementBar.classList.add('sticky-hidden');
this.announcementBar.classList.remove('sticky-announcement--fixed');
}
if (this.rowTop) this.rowTop.classList.add('sticky-hidden');
if (this.rowNav) this.rowNav.classList.add('sticky-hidden');
if (this.rowSearchMobile) this.rowSearchMobile.classList.add('sticky-hidden');

// Add fixed positioning
if (!this.isDesktop) {
this.header.classList.add('shopify-section-header-sticky');
} else {
this.header.classList.add('sticky-desktop');
}

this.closeMenuDisclosure();
this.closeSearchModal();
this.updateStickyOffset();
}

reveal(scrollDown) {
// On scroll down (when enabled): keep the header (logo + search) only, hide the nav menu.
// Announcement bar follows its own scroll-down setting.
const s = scrollDown
  ? { announcement: this.settings.scrollDown.announcement, rowTop: true, rowNav: false, search: false }
  : (this.isDesktop ? this.settings.desktop : this.settings.mobile);

this.header.classList.remove('sticky-header--hidden');
this.header.classList.add('sticky-header--reveal');

// Fixed positioning
if (!this.isDesktop) {
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
} else {
this.header.classList.add('sticky-desktop');
}

// Announcement bar: fix it above the header when enabled
if (this.announcementBar) {
if (s.announcement) {
  this.announcementBar.classList.remove('sticky-hidden');
  this.announcementBar.classList.add('sticky-announcement--fixed');
} else {
  this.announcementBar.classList.add('sticky-hidden');
  this.announcementBar.classList.remove('sticky-announcement--fixed');
}
}

// Row top (logo + search + actions)
if (this.rowTop) {
if (s.rowTop) {
  this.rowTop.classList.remove('sticky-hidden');
} else {
  this.rowTop.classList.add('sticky-hidden');
}
}

// Row nav (desktop only)
if (this.rowNav) {
if (this.isDesktop && s.rowNav) {
  this.rowNav.classList.remove('sticky-hidden');
} else if (this.isDesktop) {
  this.rowNav.classList.add('sticky-hidden');
}
}

// Search mobile
if (this.rowSearchMobile) {
if (!this.isDesktop && s.search) {
  this.rowSearchMobile.classList.remove('sticky-hidden');
} else if (!this.isDesktop) {
  this.rowSearchMobile.classList.add('sticky-hidden');
}
}

// Adjust header top offset when announcement is shown
this.updateHeaderOffset();
this.updateStickyOffset();
}

updateHeaderOffset() {
const headerWrapper = this.querySelector('.header-wrapper') || this;
if (this.announcementBar && this.announcementBar.classList.contains('sticky-announcement--fixed')) {
  headerWrapper.style.top = this.announcementBar.offsetHeight + 'px';
} else {
  headerWrapper.style.top = '0px';
}
}

updateStickyOffset() {
const headerWrapper = this.querySelector('.header-wrapper') || this;
if (this.header.classList.contains('sticky-header--hidden')) {
  document.documentElement.style.setProperty('--header-height', '0px');
  document.documentElement.style.setProperty('--topbar-height', '0px');
} else if (this.header.classList.contains('sticky-header--reveal')) {
  document.documentElement.style.setProperty('--header-height', headerWrapper.offsetHeight + 'px');
  if (this.announcementBar && !this.announcementBar.classList.contains('sticky-hidden')) {
    document.documentElement.style.setProperty('--topbar-height', this.announcementBar.offsetHeight + 'px');
  } else {
    document.documentElement.style.setProperty('--topbar-height', '0px');
  }
} else {
  document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + 'px');
  if (this.announcementBar) {
    document.documentElement.style.setProperty('--topbar-height', this.announcementBar.offsetHeight + 'px');
  }
}
}

reset() {
this.header.classList.remove('sticky-header--hidden', 'sticky-header--reveal');

// Remove all sticky-hidden and fixed
if (this.announcementBar) {
this.announcementBar.classList.remove('sticky-hidden', 'sticky-announcement--fixed');
}
if (this.rowTop) this.rowTop.classList.remove('sticky-hidden');
if (this.rowNav) this.rowNav.classList.remove('sticky-hidden');
if (this.rowSearchMobile) this.rowSearchMobile.classList.remove('sticky-hidden');

// Reset header offset
const headerWrapper = this.querySelector('.header-wrapper') || this;
headerWrapper.style.top = '';

if (!this.isDesktop) {
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
} else {
this.header.classList.remove('sticky-desktop');
}
this.updateStickyOffset();
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
if (this.searchModal !== null) {
this.searchModal.close(false);
}
}
}

customElements.define('sticky-header', StickyHeader);

class MenuDrawer extends HTMLElement {
constructor() {
super();

this.mainDetailsToggle = this.querySelector('details');
this.drawerActiveInfo = false;

this.addEventListener('keyup', this.onKeyUp.bind(this));
this.addEventListener('focusout', this.onFocusOut.bind(this));
this.bindEvents();
}

bindEvents() {
this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
this.querySelectorAll('button:not(.localization-form__select)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
}

onKeyUp(event) {
if (event.code.toUpperCase() !== 'ESCAPE') return;

const openDetailsElement = event.target.closest('details[open]');
if (!openDetailsElement) return;

openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
}

injectVariants(summary, content) {
const htmlToInject = decodeURIComponent(escape(window.atob(summary.dataset.content)));
const target = content.querySelector('.mobile-facets__wrapper');
summary.removeAttribute('data-content');
summary.dataset.toggle = 'true';
target !== null && (target.innerHTML = htmlToInject);
}

injectInfoDrawer(summary, content, event) {
this.setListener(false);

this.drawerActiveInfo = true;

const hasOption = content.querySelectorAll('.mobile-facets__inner-wrapper')
for (const item of hasOption) {
if (item.dataset.position === event.target.dataset.position) {
item.classList.remove('hidden')
}
}
}

setListener(activeChange) {
document.querySelectorAll('.js-drawer-update').forEach((item) => {
if (!activeChange && item.classList.contains('js-update-product')) return
item.addEventListener('click', this.onDrawerChange.bind(this))
})

document.querySelectorAll('.js-update-product').forEach((btn) => {
btn.addEventListener('click', function (event) {
this.closest('variant-radios').renderProductFabric(event)
}.bind(this))
})
}

onDrawerChange(event) {
const info = event.target.closest('details').querySelectorAll('.mobile-facets__inner-wrapper')
const nextPosition = event.target.dataset.position
for (const item of info) {
item.classList.add('hidden')
if (item.dataset.position === nextPosition) {
item.classList.remove('hidden')
}
}
}

onSummaryClick(event) {
const summaryElement = event.currentTarget;
const detailsElement = summaryElement.parentNode;
const parentMenuElement = detailsElement.closest('.has-submenu');
const isOpen = detailsElement.hasAttribute('open');
const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
summaryElement.hasAttribute('data-content-type') && summaryElement.dataset.contentType === "variants" && summaryElement.dataset.toggle === "false" && this.injectVariants(summaryElement, detailsElement)
if (event.target.classList.contains('option-drawer-btn') || event.target.closest('.option-drawer-btn')) !isOpen && detailsElement.setAttribute('open', "true")
!this.drawerActiveInfo && detailsElement.querySelector('.mobile-facets') && detailsElement.querySelector('.mobile-facets').dataset.contentType === "option" && this.injectInfoDrawer(summaryElement, detailsElement, event)

if (this.drawerActiveInfo) {
const currentEvent = event.target.classList.contains('has-option') ? event.target : event.target.closest('.option-drawer-btn')
if (currentEvent && currentEvent.classList.contains('has-option') && detailsElement.querySelectorAll('.mobile-facets__inner-wrapper').length > 0) {
const hasOption = detailsElement.querySelectorAll('.mobile-facets__inner-wrapper')
for (const item of hasOption) {
item.classList.add('hidden')
if (item.dataset.position === currentEvent.dataset.position) {
item.classList.remove('hidden')
}
}
}
}

function addTrapFocus() {
if (detailsElement.querySelector('button')) trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
}

if (detailsElement === this.mainDetailsToggle) {
if (isOpen) event.preventDefault();
isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
if (window.matchMedia('(max-width: 992px)')) {
document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
}
} else if (detailsElement && isOpen) {
event.preventDefault();
this.closeSubmenu(detailsElement);
} else {
setTimeout(() => {
detailsElement.classList.add('menu-opening');
summaryElement.setAttribute('aria-expanded', true);
parentMenuElement && parentMenuElement.classList.add('submenu-open');
!reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
}, 100);
}
}

openMenuDrawer(summaryElement) {
setTimeout(() => {
this.mainDetailsToggle.classList.add('menu-opening');
});
summaryElement.setAttribute('aria-expanded', true);
trapFocus(this.mainDetailsToggle, summaryElement);
document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
}

closeMenuDrawer(event, elementToFocus = false) {
if (event === undefined) return;

this.mainDetailsToggle.classList.remove('menu-opening');
this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
details.removeAttribute('open');
details.classList.remove('menu-opening');
});
this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
submenu.classList.remove('submenu-open');
});
document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
removeTrapFocus(elementToFocus);

this.closeAnimation(this.mainDetailsToggle);
}

onFocusOut(event) {
setTimeout(() => {
if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
});
}

onCloseButtonClick(event) {
if (event.target.classList.contains('option-drawer-btn') || event.target.closest('.option-drawer-btn')) return

const detailsElement = event.currentTarget.closest('details');
this.closeSubmenu(detailsElement);
}

closeSubmenu(detailsElement) {
const parentMenuElement = detailsElement.closest('.submenu-open');
parentMenuElement && parentMenuElement.classList.remove('submenu-open');
detailsElement.classList.remove('menu-opening');
detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
removeTrapFocus(detailsElement.querySelector('summary'));
this.closeAnimation(detailsElement);
}

closeAnimation(detailsElement) {
let animationStart;

const handleAnimation = (time) => {
if (animationStart === undefined) {
animationStart = time;
}

const elapsedTime = time - animationStart;

if (elapsedTime < 400) {
window.requestAnimationFrame(handleAnimation);
} else {
detailsElement.removeAttribute('open');
if (detailsElement.closest('details[open]')) {
trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
}
}
}

window.requestAnimationFrame(handleAnimation);
}
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
constructor() {
super();
}

openMenuDrawer(summaryElement) {
this.header = this.header || document.querySelector('.section-header');
this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
this.header.classList.add('menu-open');
document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
this.header.querySelector('.header-wrapper').classList.add('transparent-menu-open');

setTimeout(() => {
this.mainDetailsToggle.classList.add('menu-opening');
});

summaryElement.setAttribute('aria-expanded', true);
trapFocus(this.mainDetailsToggle, summaryElement);
document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
}

closeMenuDrawer(event, elementToFocus) {
super.closeMenuDrawer(event, elementToFocus);
this.header.classList.remove('menu-open');
this.header.querySelector('.header-wrapper').classList.remove('transparent-menu-open');
}
}

customElements.define('header-drawer', HeaderDrawer);

  } catch(e) { console.error(e); }
})();
})();
